import React, { useState } from 'react'
import styles from 'assets/jss/views/eventPageSections/generalEventsStyles.js'
import { makeStyles } from '@material-ui/core/styles'
import { Accordion, Box } from '@material-ui/core'

import SummaryPayment from 'components/Accordion/Summary/SummaryPayment'
import DetailsPayment from 'components/Accordion/Details/DetailsPayment'
import { isMobile } from 'react-device-detect'
import { DetailsPaymentMobile } from 'components/Accordion/Details/DetailsPayment'

const useStyles = makeStyles(styles)

const TicketOrder = (props) => {
  const { tickets } = props
  const classes = useStyles()
  const [expanded, setExpanded] = useState('panel0')

  const handleChange = (panel) => (event) => {
    event.preventDefault()
    setExpanded(expanded === panel ? false : panel)
  }

  const handleTicketsComponent = (ticket, index) => {
    return isMobile ? <DetailsPaymentMobile ticket={ticket} index={index} /> : <DetailsPayment ticket={ticket} index={index} />
  }

  return (
    <>
      {tickets.map((ticket, index) => {
        return (
          <div key={index}>
            <Box classes={{ root: classes.boxTickets }} id={index} data-ticket-id={index}>
              <Accordion
                classes={{
                  root: classes.accordion,
                  rounded: classes.boxAddressOptionBorder,
                }}
                expanded={expanded === `panel${index}`}
              >
                <SummaryPayment
                  handleChange={handleChange}
                  expanded={expanded === `panel${index}`}
                  index={index}
                  subcategoryName={ticket.translations}
                  placeAddress={ticket.placeAddress}
                />
                {handleTicketsComponent(ticket, index)}
              </Accordion>
            </Box>
          </div>
        )
      })}
    </>
  )
}

export default TicketOrder
